import { MATERIAL_ICON_ITEM_MAP } from "@/constants/materialIcon";
import { PIN_MATERIAL_STATUS } from "@/constants/pinMaterialStatus";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import { SOURCE_TYPE_NAMES } from "@/constants/sourceTypeIcon";
import useAppStore from "@/context/store";
import { getContentType } from "@/utils/getContentType";
import getNextDetailsSetp from "@/utils/getHistorySetp";
import { isMouseLeave } from "@/utils/isMouseLeave";
import { useMemoizedFn } from "ahooks";
import { Dropdown } from "antd";
import classNames from "classnames";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import qs from "qs";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Case, Switch, When } from "react-if";
import { EVENT } from "../../constants/event";
import { cancelShieldPin, report, shieldPin } from "../../services";
import displayNum from "../../utils/displayNum";
import imageUrl from "../../utils/imageUrl";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import Image from "../Image";
import { useLogin } from "../LoginModal";
import ReportModal from "../ReportModal";
import { TrackerA, TrackerDiv } from "../Tracker";
import styles from "./index.module.less";
import PinVideo from "./video";
const PinPreview = dynamic(import("../PinPreview"), { ssr: false });

const shieldReasonList = [
  "内容不感兴趣",
  "看到了太多次",
  "图片模糊",
  "不够美观",
  "内容引人不适",
];

function PinCard({
  user,
  pinOpenType,
  record,
  hideUser,
  showBoardLink = true,
  disableModal,
  disableFile,
  fullWidth,
  isModal,
  showDesc = false,
  showMaterialTag = true,
  showSeries = false,
  onMouseEnterCard,
  onMouseLeaveCard,
  searchWord,
  imgLoading = "lazy",
  width = 240,
}) {
  const [hover, setHover] = useState(false);
  const [play, setPlay] = useState(false);
  const [pin, setPin] = useState(record);
  const [bgColor, setBgColor] = useState(record?.file?.theme || "EDF2F5");
  const { login } = useLogin();
  const router = useRouter();
  const currentSrcRef = useRef(null);
  const imageRef = useRef(null);

  const isGif = useMemo(() => {
    return pin.file?.type === "image/gif";
  }, [pin]);
  const meterialCategory = useMemo(() => {
    return pin.file_material?.material_category;
  }, [pin]);
  const isVideo = useMemo(() => {
    return meterialCategory === "视频模板" || meterialCategory === "视频";
  }, [meterialCategory]);

  const contentType = useMemo(() => {
    return getContentType(pin);
  }, [pin]);
  const videoTime = useMemo(() => {
    let duration = pin.file_material?.extra?.duration;
    duration = ~~(duration / 1000);
    const hh = Math.floor(duration / 3600);
    duration -= hh * 3600;
    const mm = Math.floor(duration / 60);
    duration -= mm * 60;
    const ss = duration;
    const appendZeroStr = (num) => (num < 10 ? "0" + num : num);
    return `${appendZeroStr(mm)}:${appendZeroStr(ss)}`;
  }, [pin]);

  useEffect(() => {
    const onUpdate = (evt) => {
      const record = evt.detail;
      if (record?.pin_id === pin?.pin_id) {
        // 保留feed流中特殊属性，避免feed流中 sourceType 相关字段丢失
        setPin({
          ...pin,
          ...record,
        });
      }
    };

    window.addEventListener(EVENT.UPDATE_PIN, onUpdate);

    return () => {
      window.removeEventListener(EVENT.UPDATE_PIN, onUpdate);
    };
  }, [pin]);

  const videoRef = useRef(null);
  const hoverDelay = useRef(null);
  const onHover = useCallback(
    (hover) => {
      const video = videoRef.current;
      // 停止播放，减少视频加载流量， 不做处理视频的请求会一直继续加载
      if (video && !hover) {
        video.pause();
        video.src = "";
        // video.load();
      }
      if (hover && (isVideo || isGif)) {
        // 延迟视频加载
        hoverDelay.current = setTimeout(() => {
          setHover(hover);

          if (isGif) {
            setPlay(true); // gif图移动上去后永远播放
          }
        }, 300);
      } else {
        if (hoverDelay.current) {
          clearTimeout(hoverDelay.current);
        }
        setHover(hover);
      }
    },
    [isGif, isVideo]
  );

  const onDetail = useCallback(
    (evt) => {
      if (evt.metaKey || evt.ctrlKey || pinOpenType === PIN_OPEN_TYPE.BLANK) {
        return;
      }
      onHover(false);
      onMouseLeaveCard && onMouseLeaveCard(pin);

      evt.preventDefault();

      if (disableModal) {
        // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
        window._pinDetailCurrentSrc = currentSrcRef.current;
        router.push(`/pins/${pin.pin_id}`);
        return;
      }
      useAppStore.setState({
        currentPin: {
          ...pin,
          pinId: pin.pin_id,
          // 用于渐进式显示图片，先显示缓存图，再显示大图
          currentSrc: currentSrcRef.current,
          ...(searchWord ? { searchWord } : null),
          ...(!disableFile ? { file: pin.file } : null),
        },
      });
      // 弹窗内切换需要记录push的步骤
      let detailsSetp = getNextDetailsSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      window.history.pushState(
        isModal ? { ...historyData, detailsSetp } : null,
        null,
        `/pins/${pin.pin_id}`
      );
    },
    [
      pinOpenType,
      onHover,
      onMouseLeaveCard,
      pin,
      disableModal,
      disableFile,
      isModal,
      router,
      searchWord,
    ]
  );

  // 跳转对象详情
  const onLinkFollowerDetail = (pin) => {
    const { source_type, source_detail } = pin;
    let source_link = "";

    if (source_type === 1) {
      // 画板
      source_link = `/boards/${source_detail?.board_id}`;
    } else if (source_type === 2) {
      // 用户
      source_link = `/user/${source_detail?.urlname}`;
    } else if (source_type === 3) {
      // 来源
      source_link = `/domains/${source_detail?.domain_id}`;
    }
    window.open(source_link);
  };

  const onImgLoad = useCallback((evt) => {
    currentSrcRef.current = evt.target.currentSrc;
    setBgColor(null);
  }, []);

  const userDom = useMemo(() => {
    return (
      <TrackerA
        className={styles.user}
        href={`/user/${pin.user?.urlname}`}
        target="_blank"
        data-gd-click="button_click"
        data-button-name="去个人页"
        data-content-id={pin.pin_id}
        data-board-id={pin.board_id}
        title={pin.user?.username}
      >
        <div className={styles.avatar}>
          <img
            alt={pin.user?.username || "查看用户"}
            src={
              pin.user?.avatar_url ||
              imageUrl(pin.user?.avatar, { width: 75, rect: "sq" })
            }
            loading="lazy"
          />
        </div>
        <div className={styles.name}>{pin.user?.username}</div>
      </TrackerA>
    );
  }, [pin]);

  const boardDom = useMemo(() => {
    return (
      <div className={styles.board}>
        <TrackerA
          className={styles.link}
          href={`/boards/${pin.board_id}`}
          data-gd-click="button_click"
          data-button-name="去画板"
          target="_blank"
          title={pin.board?.title || "查看画板"}
        >
          <div className={styles.label}>画板</div>
          <div className={styles.title}>{pin.board?.title}</div>
        </TrackerA>
        <PinPreview className={styles.button} pin={pin} />
      </div>
    );
  }, [pin]);

  const onReport = useCallback(async () => {
    if (!user) {
      const result = await login({
        source_location: "举报采集",
      });
      if (!result) {
        return;
      }
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: record?.pin_id,
      reportBoardId: record?.board_id,
      reportContentId: record?.file_material?.material_id,
      reportFileId: record?.file_id,
      pin: record,
      contentType: contentType,
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: record?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  }, [login, record, user, contentType]);

  /** 屏蔽 */
  const onShield = useCallback(async () => {
    if (!user) {
      const result = await login({
        source_location: "采集屏蔽",
      });
      if (!result) {
        return;
      }
    }

    const result = await shieldPin({
      item_type: 1,
      item_value: pin?.file_id,
    });

    if (!result.err) {
      setPin((pin) => ({
        ...pin,
        shieldStatus: "reason",
      }));
      // 必须更新一下，不然瀑布流销毁状态就会消失
      record.shieldStatus = "reason";
    }
  }, [login, pin, user, record]);

  /** 取消屏蔽*/
  const onCancelShield = useCallback(async () => {
    const result = await cancelShieldPin({
      item_type: 1,
      item_value: pin?.file_id,
    });

    if (!result.err) {
      setPin((pin) => ({
        ...pin,
        shieldStatus: "",
      }));
      // 必须更新一下，不然瀑布流销毁状态就会消失
      record.shieldStatus = "";
    }
  }, [pin, record]);

  /** 屏蔽原因 */
  const onShieldReason = useCallback(
    async (reason) => {
      const result = await shieldPin({
        item_type: 1,
        item_value: pin?.file_id,
        reason,
      });

      if (!result.err) {
        setPin((pin) => ({
          ...pin,
          shieldStatus: "show",
        }));
        // 必须更新一下，不然瀑布流销毁状态就会消失
        record.shieldStatus = "show";
      }
    },
    [pin, record]
  );

  const moreMenu = useMemo(() => {
    return (
      <div
        className={styles.menu}
        data-content-type={contentType}
        style={pin.source_type ? { width } : {}}
        title={
          pin.source_type
            ? `此采集来自你关注的${SOURCE_TYPE_NAMES[pin.source_type]} ${
                pin.source_detail?.domain_name ||
                pin.source_detail?.title ||
                pin.source_detail?.username
              }`
            : undefined
        }
      >
        {pin.source_type && (
          <div className={styles.source}>
            此采集来自你关注的{SOURCE_TYPE_NAMES[pin.source_type]}
            <span onClick={() => onLinkFollowerDetail(pin)}>
              {pin.source_detail?.domain_name ||
                pin.source_detail.title ||
                pin.source_detail.username}
            </span>
          </div>
        )}
        <TrackerA
          className={styles.menuItem}
          onClick={onShield}
          data-gd-click="button_click"
          data-button-name="屏蔽"
          data-report-type="采集"
          data-report-pin-id={record?.pin_id}
          data-report-file-id={record?.file_id}
          data-report-content-id={record?.file_material?.material_id}
        >
          <span className={styles.text}>屏蔽采集</span>
        </TrackerA>
        <TrackerA
          className={styles.menuItem}
          onClick={onReport}
          data-gd-click="button_click"
          data-button-name="举报"
          data-report-type="采集"
          data-report-pin-id={record?.pin_id}
          data-report-file-id={record?.file_id}
          data-report-content-id={record?.file_material?.material_id}
        >
          <span className={styles.text}>举报采集</span>
        </TrackerA>
      </div>
    );
  }, [onReport, onShield, record, pin, contentType]);

  const wrapRef = useRef();

  const onMouseLeave = useCallback(
    (e) => {
      onHover(false);
      if (isMouseLeave(e, wrapRef.current)) {
        onMouseLeaveCard && onMouseLeaveCard(pin);
      }
    },
    [onHover, onMouseLeaveCard, pin]
  );

  const onMouseEnter = useMemoizedFn(() => {
    onHover(true); // 解决关闭弹窗后，没有触发鼠标MouseEnter事件
    onMouseEnterCard?.({
      pin,
      imageDom: imageRef.current,
      onUpdatePin: setPin,
    });

    if (pin.mask) {
      pin.mask = false;
      window.dispatchEvent(new Event(EVENT.HIDE_MASK));
    }
  });

  const onOperate = () => {
    // 关注页面需要记录用户有没有操作
    if (router.pathname === "/follow") {
      window.dispatchEvent(new Event(EVENT.CARD_OPERATE));
    }
  };

  const materialIcon = useMemo(() => {
    return (
      MATERIAL_ICON_ITEM_MAP[pin.file_material?.material_type?.toLowerCase()] ||
      MATERIAL_ICON_ITEM_MAP["default"]
    );
  }, [pin]);

  return (
    <div
      ref={wrapRef}
      className={classNames(styles.card, {
        [styles.fullWidth]: fullWidth,
      })}
      data-pin-id={pin.pin_id}
      onClick={onOperate}
      // onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseOver={onMouseEnter}
    >
      <div className={styles.container}>
        {/* 图片 */}
        <TrackerDiv
          ref={imageRef}
          className={styles.img}
          data-gd-expose="content_expose"
          data-gd-click="material_click"
          data-unique-id={pin.pin_id}
          data-content-id={pin.pin_id}
          data-content-type={contentType}
          data-material-id={pin.file_material?.material_id}
          data-ext={JSON.stringify(pin?.ext)}
          data-board-id={pin.board_id}
          data-file-id={pin.file_id}
          data-material-type={
            pin?.file_material?.extra?.group_ids ? "套系素材" : ""
          }
          data-check-cover
          style={bgColor ? { backgroundColor: `#${bgColor}` } : null}
        >
          {fullWidth && (pin.repin_count || pin.text_meta?.creation) && (
            <div className={styles.info}>
              <When condition={pin.repin_count}>
                <div className={styles.item}>
                  <div
                    className={styles.num}
                    title={`转采：${pin.repin_count}`}
                  >
                    <HBIcon className={styles.icon} type="ic_zc1" />
                    <div className={styles.text}>
                      {displayNum(pin.repin_count)}
                    </div>
                  </div>
                </div>
              </When>
              <When condition={pin.text_meta?.creation}>
                <div className={styles.item}>
                  <HBIcon className={styles.draw} type="draw2" />
                  <span className={styles.text}>原创</span>
                </div>
              </When>
            </div>
          )}
          <div className={styles.bottomInfo}>
            {showSeries && pin?.file_material?.extra?.group_ids && (
              <div className={classNames(styles.series, styles.item)}>
                <HBIcon type="hk_complex" />
              </div>
            )}
            {showMaterialTag &&
              pin.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE && (
                <div className={classNames(styles.material, styles.item)}>
                  <div
                    className={styles.icon}
                    style={{
                      backgroundColor: materialIcon.color,
                    }}
                  >
                    <HBIcon type={materialIcon.icon} />
                  </div>
                  <div className={styles.text}>
                    {materialIcon?.label || "素材"}
                  </div>
                </div>
              )}
            {pin?.extra?.aigc === 1 &&
            pin.file_material?.status !== PIN_MATERIAL_STATUS.AVAILABLE ? (
              <div className={classNames(styles.ai, styles.item)}>
                <HBIcon className={styles.icon} type="ai" />
                <div className={styles.text}>生成</div>
              </div>
            ) : null}
            {pin?.extra?.aigc === 0 &&
            pin.file_material?.status !== PIN_MATERIAL_STATUS.AVAILABLE ? (
              <div className={classNames(styles.ai, styles.item)}>
                <div className={styles.text}>疑似</div>
                <HBIcon className={styles.icon} type="ai" />
              </div>
            ) : null}
            {isGif && !isVideo && !play && (
              <div className={classNames(styles.gif, styles.item)}>GIF</div>
            )}
            {isVideo && !hover && (
              <div className={classNames(styles.video, styles.item)}>
                {videoTime}
              </div>
            )}
          </div>
          <a
            className={styles.link}
            href={`/pins/${pin.pin_id}${qs.stringify(
              { searchWord },
              { addQueryPrefix: true }
            )}`}
            target="_blank"
            onClick={onDetail}
            draggable={false}
          >
            {isVideo && hover && (
              <PinVideo
                ref={videoRef}
                fullWidth={fullWidth}
                pin={pin}
                width={width}
              />
            )}

            <Image
              className="transparent-img-bg"
              alt={pin.raw_text}
              src={imageUrl(pin.file, {
                width: fullWidth ? 1200 : 240,
                gif: play && isGif,
              })}
              draggable={false}
              srcSet={
                imageUrl(pin.file, {
                  width: fullWidth ? 1200 * 2 : 480,
                  gif: play && isGif,
                }) + " 2x"
              }
              width={Math.min(fullWidth ? 1200 : width, pin.file?.width)}
              height={Math.round(
                (pin.file?.height / pin.file?.width) *
                  Math.min(fullWidth ? 1200 : width, pin.file?.width)
              )}
              loading={imgLoading}
              style={bgColor ? { background: "none" } : null}
              onLoad={onImgLoad}
              showError={true}
              title={pin.raw_text}
            />
            <span style={{ display: "none" }}>{pin?.raw_text}</span>
            {record.mask && <div className={styles.mask}>刚刚访问</div>}
          </a>
        </TrackerDiv>
        <When condition={showDesc && pin?.raw_text}>
          <a
            className={styles.pinDesc}
            title={pin?.raw_text || ""}
            href={`/pins/${pin.pin_id}${qs.stringify(
              { searchWord },
              { addQueryPrefix: true }
            )}`}
            target="_blank"
            onClick={onDetail}
          >
            {pin?.raw_text || ""}
          </a>
        </When>
        {/* 用户信息 */}
        <When condition={!hideUser || showBoardLink}>
          <div className={styles.info}>
            <Switch>
              <Case condition={!hideUser && showBoardLink}>
                <div className={styles.left}>{userDom}</div>
                <div className={styles.right}>{boardDom}</div>
              </Case>
              <Case condition={hideUser && showBoardLink}>{boardDom}</Case>
              <Case condition={!hideUser && !showBoardLink}>{userDom}</Case>
            </Switch>
          </div>
        </When>
        <When condition={!fullWidth}>
          <div className={styles.operation} data-content-type={contentType}>
            <div className={styles.left}>
              <div className={styles.button} title={`转采：${pin.repin_count}`}>
                <HBIcon className={styles.icon} type="ic_zc1" />
                {pin.repin_count > 0 && (
                  <div className={styles.text}>
                    {displayNum(pin.repin_count)}
                  </div>
                )}
              </div>
              <div className={styles.button} title={`喜欢：${pin.like_count}`}>
                <HBIcon
                  className={classNames([
                    styles.icon,
                    pin.liked ? styles.active : null,
                  ])}
                  type={pin.liked ? "ic_favorite" : "ic_like"}
                />

                {pin.like_count > 0 && (
                  <div className={styles.text}>
                    {displayNum(pin.like_count)}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.right}>
              <Dropdown overlay={moreMenu} placement="bottomRight">
                <div className={styles.button}>
                  <HBIcon className={styles.icon} type="ic_more" />
                </div>
              </Dropdown>
            </div>
          </div>
        </When>
      </div>
      {pin?.shieldStatus && (
        <div className={styles.shield}>
          <div className={styles.text}>
            {pin?.shieldStatus === "reason"
              ? "已屏蔽，请告诉我们原因为你优化推荐结果"
              : "已收到你的反馈，将为你优化推荐结果"}
          </div>
          {pin?.shieldStatus === "reason" && (
            <div className={styles.reason}>
              {shieldReasonList.map((reason, index) => (
                <div
                  className={styles.item}
                  key={index}
                  onClick={() => onShieldReason(reason)}
                  data-gd-click="button_click"
                  data-button-name="屏蔽原因"
                  data-report-reason={reason}
                  data-content-id={record?.pin_id}
                  data-board-id={record?.board_id}
                  data-file-id={record?.file_id}
                  data-report-content-id={record?.file_material?.material_id}
                >
                  {reason}
                </div>
              ))}
            </div>
          )}
          <div className={styles.linkContainer}>
            <a className={styles.link} onClick={onCancelShield}>
              取消屏蔽
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(PinCard);
